import api from './api';
import { IAIHistory, PaginatedResponse, PaginationParams } from '../types';

export interface GenerateAIDataPayload {
    type: 'company' | 'contact' | 'application';
    message: string;
}

export interface GenerateAIDataResponse {
    data: any;
    confidence: number;
}

export const generateAIData = async (payload: GenerateAIDataPayload): Promise<GenerateAIDataResponse> => {
    console.log('generateAIData', payload)
    const { data } = await api.post('/api/ai/generate', payload);
    return data;
};

export const getAIHistory = async (params: PaginationParams = {}): Promise<PaginatedResponse<IAIHistory>> => {
    const { data } = await api.get('/api/ai/history', { params });
    return {
        data: data.history,
        pagination: data.pagination
    };
};